import { Button, Container } from "react-bootstrap";

const BenefitsList = ({ title, benefits = [] }) => {
    return (
        <>
            <section className="benefits-section">
                <Container fluid className="p-4 p-lg-5">
                    <h2 className="text-primary mb-0 text-uppercase ft-wt-600 mb-2 mb-lg-4">{title}</h2>
                    <ul className="list-block mb-4">
                        {benefits.map((benefit, index) => (
                            <li className="text-primary" key={index}><p className="mb-0">{benefit}</p></li>
                        ))}
                    </ul>
                    <div>
                        <a href="https://calendly.com/sairam-acubetechnologies" target="_blank" rel="noopener noreferrer">
                            <Button className="" variant="primary">Book A discovery call</Button>
                        </a>
                    </div>
                </Container>
            </section>
        </>
    );
};

export default BenefitsList;
